import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Sidemenu from '../Layout/Sidemenu';
import Topbar from '../Layout/Topbar';
import Footer from '../Layout/Footer';
import { apiurl, backendurl } from '../Config/Config';
import { Commonhelper } from '../Helpers/Commonhelper';
import axios from 'axios';
import { AiOutlineLoading } from "react-icons/ai";
import { FaAngleLeft, FaAngleRight, FaIdBadge, FaExclamationTriangle, FaCheck } from 'react-icons/fa';
import { MdOutlineEdit, MdOutlineDeleteOutline } from "react-icons/md";
import Select from 'react-select';

const Idcards = () => {
    const navigate = useNavigate();
    const modalRef = useRef(null);

    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ id: '', name: '', file_number: '', civil_id_number: '', designation: '', expiry_date: '', file: null });
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(Commonhelper.recordsPerPage);
    const [totalRecords, setTotalRecords] = useState(0);
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);

    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');


    useEffect(() => {
        if (Commonhelper.checkSession === false) {
            navigate("/login");
        } else if(localStorage.getItem("user_type") === "user") {
            navigate("/dashboard");
        }else {
            fetchIdcards({ offset: 0, recordsPerPage, unique_id: localStorage.getItem('unique_id') });
        }
    }, [navigate]);

    const fetchIdcards = async (postObj) => {
        try {
            var qs = require('qs');
            const response = await axios.post(apiurl + 'idcards/list', qs.stringify(postObj));
            if (response.data.status === "success") {
                setData(response.data.data);
                setTotalRecords(response.data.total_records);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const openModal = (item = null) => {
        if (item) {
            setFormData({
                id: item.id,
                name: item.name,
                file_number: item.file_number,
                civil_id_number: item.civil_id_number,
                designation: item.designation,
                expiry_date: item.expiry_date,
                file: null // we keep this null initially; user may choose to upload new
            });
            setPreviewUrl(backendurl + 'uploads/idcards/' + item.file); // adjust if your file is stored differently
            setIsEditMode(true);
        } else {
            setFormData({ id: '', name: '', file_number: '', civil_id_number: '', designation: '', expiry_date: '', file: null });
            setIsEditMode(false);
        }
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setPreviewUrl(null);
        setErrorMsg('');
        setSuccessMsg('');
    };


    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'file') {
            const file = files[0];
            if (file) {
                const allowedTypes = ['application/pdf', 'image/jpeg'];
                if (!allowedTypes.includes(file.type)) {
                    alert('Only PDF and JPEG files are allowed.');
                    e.target.value = ''; // clear invalid file
                    return;
                }
                setFormData({ ...formData, file });
                // generate preview url for selected file
                setPreviewUrl(URL.createObjectURL(file));

            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };


    const handleSubmit = async () => {
        setErrorMsg('');
        setSuccessMsg('');

        const { name, file_number, civil_id_number, designation, expiry_date, file } = formData;

        // Validation
        if (!name || !file_number || !civil_id_number || !designation || !expiry_date) {
            setErrorMsg('All fields are required.');
            if (modalRef.current) {
                modalRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            }

            return;
        }

        if (!isEditMode && !file) {
            setErrorMsg('File is required.');
            if (modalRef.current) {
                modalRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            }

            return;
        }


        setIsSubmitting(true);

        try {
            const form = new FormData();
            Object.keys(formData).forEach(key => {
                if (formData[key]) form.append(key, formData[key]);
            });
            var url = isEditMode ? 'idcards/update' : 'idcards/add';
            const response = await axios.post(apiurl + url, form);

            if (response.data.status === "success") {
                setSuccessMsg(isEditMode ? 'ID Card updated successfully!' : 'ID Card added successfully!');
                if (modalRef.current) {
                    modalRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                }

                setTimeout(() => {
                    closeModal();
                    setSuccessMsg('');
                }, 2000);
                fetchIdcards({ offset: (currentPage - 1) * recordsPerPage, recordsPerPage, unique_id: localStorage.getItem('unique_id') });
            } else {
                setErrorMsg(response.data.message || 'Something went wrong. Please try again.');
                if (modalRef.current) {
                    modalRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                }

            }
        } catch (err) {
            console.error(err);
            setErrorMsg('An unexpected error occurred.');
            if (modalRef.current) {
                modalRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            }

        } finally {
            setIsSubmitting(false);
        }
    };


    const handleDelete = async (id) => {
        if (window.confirm("Are you sure to delete this ID card?")) {
            try {
                var qs = require('qs');
                await axios.post(apiurl + 'idcards/delete', qs.stringify({ id }));
                fetchIdcards({ offset: (currentPage - 1) * recordsPerPage, recordsPerPage, unique_id: localStorage.getItem('unique_id') });
            } catch (err) {
                console.error(err);
            }
        }
    };

    const navigatePage = (page) => {
        setCurrentPage(page);
        fetchIdcards({ offset: (page - 1) * recordsPerPage, recordsPerPage, unique_id: localStorage.getItem('unique_id') });
    };

    function PaginationControls() {
        const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
        const transformedData = pages.map((number) => ({ label: number, value: number }));
        const pagetotal = ((currentPage * recordsPerPage) > totalRecords ? totalRecords : (currentPage * recordsPerPage));
        return (
            <div className="page-btn-div">
                <span className="pagination-count">{(currentPage - 1) * recordsPerPage + 1} - {pagetotal} of {totalRecords} Entries</span>
                <button onClick={() => navigatePage(currentPage - 1)} disabled={currentPage === 1}><FaAngleLeft /></button>
                <Select
                    className='custom-pagination-page-numbers'
                    options={transformedData}
                    value={{ value: currentPage, label: currentPage }}
                    onChange={(e) => navigatePage(e.value)}
                />
                <button onClick={() => navigatePage(currentPage + 1)} disabled={currentPage === totalPages}><FaAngleRight /></button>
            </div>
        );
    }

    return (
        <div className="container-scroller">
            <Topbar />
            <div className="container-fluid page-body-wrapper panel-area">
                <Sidemenu />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="page-header">
                            <h3 className="page-title">
                                <span className="page-title-icon bg-gradient-primary text-white me-2"><FaIdBadge /></span> ID Cards
                            </h3>
                            <nav aria-label="breadcrumb">
                                <ul className="breadcrumb">
                                    <button className='btn btn-gradient-primary brd-btn' onClick={() => openModal()}>Add New</button>
                                </ul>
                            </nav>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <table className="table table-hover list-table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>File Number</th>
                                                    <th className="mobile_col">Civil ID</th>
                                                    <th className="mobile_col">Designation</th>
                                                    <th className="mobile_col">Expiry Date</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.length > 0 ? data.map(item => (
                                                    <tr key={item.id}>
                                                        <td>{item.name}</td>
                                                        <td>{item.file_number}</td>
                                                        <td className="mobile_col">{item.civil_id_number}</td>
                                                        <td className="mobile_col">{item.designation}</td>
                                                        <td className="mobile_col">{item.expiry_date}</td>
                                                        <td>
                                                            <MdOutlineEdit onClick={() => openModal(item)} className="table-action-icon" />
                                                            <MdOutlineDeleteOutline onClick={() => handleDelete(item.id)} className="table-action-icon" />
                                                        </td>
                                                    </tr>
                                                )) : <tr><td style={{ textAlign: 'center' }} colSpan="6">No Records found</td></tr>}
                                            </tbody>
                                        </table>
                                        <div className="pagination-div"><PaginationControls /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>

            {/* Popup Modal */}
            {showModal && (
                <div className="modal-backdrop">
                    <div className="modal-box" ref={modalRef}>
                        <h4>{isEditMode ? 'Edit ID Card' : 'Add New ID Card'}</h4>

                        <div className='err-display' style={{ display: (errorMsg) ? 'block' : 'none', textAlign: 'left' }}> <FaExclamationTriangle /> <p>{errorMsg}</p></div>
                        <div className='success-display' style={{ display: (successMsg) ? 'block' : 'none', textAlign: 'left' }}> <FaCheck /> <p>{successMsg}</p></div>
                        <br />
                        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Name" />
                        <input type="text" name="file_number" value={formData.file_number} onChange={handleChange} placeholder="File Number" />
                        <input type="text" name="civil_id_number" value={formData.civil_id_number} onChange={handleChange} placeholder="Civil ID Number" />
                        <input type="text" name="designation" value={formData.designation} onChange={handleChange} placeholder="Designation" />
                        <input type="date" name="expiry_date" value={formData.expiry_date} onChange={handleChange} />
                        {previewUrl && (
                            previewUrl.endsWith('.pdf') ? (
                                <iframe src={previewUrl} width="100%" height="400px" title="PDF preview"></iframe>
                            ) : (
                                <img src={previewUrl} alt="Preview" style={{ width: '100%', marginBottom: '10px' }} />
                            )
                        )}
                        <input type="file" name="file" onChange={handleChange} accept=".pdf,.jpg,.jpeg" />
                        <button className='btn btn-gradient-primary' disabled={isSubmitting} onClick={handleSubmit}>{isSubmitting ? (isEditMode ? 'Updating...' : 'Adding...') : (isEditMode ? 'Update' : 'Add')}</button>
                        <button className='btn btn-light' onClick={closeModal}>Cancel</button>
                    </div>
                </div>
            )}

        </div>
    );
}

export default Idcards;
